import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LocalStorageService } from '../../../services/base/local-storage.service';

@Component({
  selector: 'fury-toolbar-darkmode-toggle',
  templateUrl: './toolbar-darkmode-toggle.component.html',
  styleUrls: ['./toolbar-darkmode-toggle.component.scss']
})
export class ToolbarDarkmodeToggleComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document,
              private localStorageService: LocalStorageService) {
  }

  ngOnInit(): void {
    const darkModeEnabled = this.localStorageService.get('dark-mode');

    if (darkModeEnabled !== null) {
      if (darkModeEnabled) {
        this.toggle();
      }
    }
  }

  toggle(): void {
    const classList: DOMTokenList = this.document.body.classList;

    if (classList.contains('fury-dark')) {
      classList.remove('fury-dark');
      classList.add('fury-default');
    } else {
      classList.remove('fury-default');
      classList.add('fury-dark');
    }
  }
}
